import { createAction, props } from '@ngrx/store';
import { iComentarios } from '../../entrada/entrada.interface';

export const cargaComentarios = createAction('[Comentarios Component] cargaComentarios', props<{ oComentarios: iComentarios[] }>());
export const resetComentarios = createAction('[Comentarios Component] resetComentarios');
